import { render, staticRenderFns } from "./ManageSider.vue?vue&type=template&id=76f5ed20&scoped=true"
import script from "./ManageSider.vue?vue&type=script&lang=js"
export * from "./ManageSider.vue?vue&type=script&lang=js"
import style0 from "./ManageSider.vue?vue&type=style&index=0&id=76f5ed20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f5ed20",
  null
  
)

export default component.exports